import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
//引入封装Axios请求
import api from "./components/request/axios";
// 引入 JsBarcode
import jsbarcode from 'jsbarcode'
// 引入ElementPlus组件库
import ElementPlus from 'element-plus'
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import 'element-plus/dist/index.css'
//引入css公共样式
import "../src/assets/global.less";
// 定义全局变量
const app = createApp(App);
// app.config.globalProperties.$ImgUrl = 'http://192.168.1.30:8088/';
app.config.globalProperties.$ImgUrl = 'https://bxzs.gxbys.org.cn/';
app.use(store).use(router).use(api).use(jsbarcode).use(ElementPlus, {locale: zhCn,}).mount("#app");

// 在 main.js 或 main.ts 文件中

// 检查是否在生产环境中
// development 开发环境
// production 生产环境
if (process.env.NODE_ENV === 'production') {
    // 保存原始 console 对象（可选，用于恢复）
    const originalConsole = console;

    // 重写 console 的方法以阻止输出
    console.log = console.error = console.warn = console.info = function() {};
	
    // 如果你想在将来的某个时间点恢复 console，可以这样做：
    // window.console = originalConsole;
  }

  // ... 你的 Vue 应用初始化代码 ...
